
/**
 * Wait for the CustomerFieldsApp object to be ready.
 */
function customerFieldsAppReady() {
  return new Promise((resolve) => {
    const checkInterval = setInterval(() => {
      if (typeof window['CustomerFieldsApp'] !== 'undefined') {
        clearInterval(checkInterval);
        resolve(window['CustomerFieldsApp']);
      }
    }, 100);
  });
}

/**
 * The CustomerFieldsApp object is ready and callbacks can be added to it.
 */
customerFieldsAppReady().then((cf_app) => {


  const error1 = window.validateRegisterMessage.title;
  const error2 = window.validateRegisterMessage.label;
  const error3 = window.validateRegisterMessage.password;
  const errorChar = window.validateRegisterMessage.charpassword;
  const errorDigit = window.validateRegisterMessage.digitpassword;
  const errorFirstName = window.validateRegisterMessage.firstName;
  const errorLastName = window.validateRegisterMessage.lastName;
  const errorEmail = window.validateRegisterMessage.email;

  let lastFocusedField = null;

  cf_app.settings.onFieldsLoaded = function (form) {
    const firstNameInput = form.querySelector('input[name="customer[first_name]"]');
    const lastNameInput = form.querySelector('input[name="customer[last_name]"]');
    const emailInput = form.querySelector('input[name="customer[email]"]');

    if (firstNameInput) {
      firstNameInput.addEventListener('blur', function () {
        validateField(firstNameInput, firstNameInput.closest('.cf-app__field'));
      });
    }
    if (lastNameInput) {
      lastNameInput.addEventListener('blur', function () {
        validateField(lastNameInput, lastNameInput.closest('.cf-app__field'));
      });
    }
    if (emailInput) {
      emailInput.addEventListener('blur', function () {
        validateField(emailInput, emailInput.closest('.cf-app__field'));
      });
    }
    const passwordField = form.querySelector('input[type="password"]');
    const selectField = form.querySelector('select[type="select"]');
    if(selectField){
      selectField.setAttribute('aria-label', 'Title selection');
    }
    if (passwordField) {
      const customDiv = document.createElement('div');
      customDiv.className = 'password-info';
      customDiv.textContent = error3;

      // Add inline styles
      customDiv.style.color = '#595959';
      customDiv.style.font = 'normal 400 14px "Gothic-720", "Helvetica Neue", Helvetica, Arial, sans-serif';
      customDiv.style.lineHeight = '18px';
      customDiv.style.letterSpacing = '-0.029rem';
      customDiv.style.marginTop = '10px';
      customDiv.style.textAlign = 'left';

      passwordField.parentNode.insertBefore(customDiv, passwordField.nextSibling);
    }

    // Add event listener to track the last focused field
    const formFields = form.querySelectorAll('.cf-app__field');
    formFields.forEach(field => {
      const input = field.querySelector('input, select, textarea');
      if (input) {
        input.addEventListener('focus', function () {
          lastFocusedField = input;
        });
      }
    });

    // Add event listener to the document
    document.addEventListener('click', function (event) {
      const isClickInsideForm = form.contains(event.target);
      if (!isClickInsideForm && lastFocusedField) {
        // Validate only the last focused field
        const lastFocusedFieldContainer = lastFocusedField.closest('.cf-app__field');
        validateField(lastFocusedField, lastFocusedFieldContainer);
        lastFocusedField = null; // Reset the last focused field
      }
    });
  };

  function validateField(input, field) {
    let isValid = true;
    const label = field.querySelector('label');
    let errorContainer = field.querySelector('.form-error-message');
    const customDiv = field.querySelector('.password-info');  // Find the custom message div
    const validNamePattern = /^[a-zA-Z\s]*$/;

    if (input && label) {
      const fieldName = label.textContent.replace('*', '').trim();
      const inputName = input.getAttribute('name');
      // Create error container if it doesn't exist
      if (!errorContainer) {
        errorContainer = document.createElement('div');
        errorContainer.className = 'form-error-message';
        // Insert error container before the custom message
        if (customDiv) {
          field.insertBefore(errorContainer, customDiv);
        } else {
          field.appendChild(errorContainer);
        }
      }
      if (inputName === 'customer[first_name]') {
        const validNamePattern = /^[a-zA-Z\s]*$/;

        if (!validNamePattern.test(input.value) || input.value.trim() === "") {
            isValid = false;
            errorContainer.textContent = errorFirstName;
            field.classList.add('form-error');
        }else {
            errorContainer.textContent = '';
            field.classList.remove('form-error');
        }
      }
      else if (inputName === 'customer[last_name]') {
        const validNamePattern = /^[a-zA-Z\s]*$/;

        if (!validNamePattern.test(input.value) || input.value.trim() === "") {
          isValid = false;
          errorContainer.textContent = errorLastName;
          field.classList.add('form-error');
        }else {
          errorContainer.textContent = '';
          field.classList.remove('form-error');
      }
      }else if (inputName === 'customer[email]') {
        const email = input.value.trim();

        const tempInput = document.createElement('input');
        tempInput.type = 'email';
        tempInput.value = email;
        const isEmailValid = tempInput.checkValidity();

        const customPattern = /^[a-zA-Z0-9._%+-]+(?<!\.)@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
        const isPatternValid = customPattern.test(email);

        if (!isEmailValid || !isPatternValid) {
          isValid = false;
          errorContainer.textContent = errorEmail;
          field.classList.add('form-error');
        } else {
          errorContainer.textContent = '';
          field.classList.remove('form-error');
        }
    }else if (input.type === 'password') {
        // Password validation
        const password = input.value;
        let passwordError = '';
        if (password.length < 8 || password.length > 25) {
          passwordError = errorChar;
        } else if (!/\d/.test(password)) {
          passwordError = errorDigit;
        }
        if (passwordError) {
          isValid = false;
          errorContainer.textContent = passwordError;
          field.classList.add('form-error');
        } else {
          errorContainer.textContent = '';
          field.classList.remove('form-error');
        }
      } else {
        errorContainer.textContent = '';
        field.classList.remove('form-error');
      }
    }

    return isValid;
  }

  function validateForm(form) {

    let isValid = true;

    // Custom validation logic
    const formFields = form.querySelectorAll('.cf-app__field');

    formFields.forEach(field => {
      const input = field.querySelector('input, select, textarea');
      if (input) {
        if (!validateField(input, field)) {
          isValid = false;
        }
      }
    });

    return isValid; // Return true if the form is valid, otherwise false
  }

  cf_app.settings.validateBeforeSubmit = function (form) {
    return validateForm(form);
  };

  cf_app.settings.onNewCustomerSuccess = function (form) {
    window.location.href = window.routes.login_url + '?registered=true';
  };
});
